// <s-sticky-buy> — mobile purchase bar shown while the main add-to-cart ([data-main-add]) is scrolled past,
// and hidden again while any [data-sticky-buy-hide] region (e.g. recommendations) is on screen.
class SStickyBuy extends HTMLElement {
  #observer;
  #mainPassed = false;
  #hideVisible = new Set();

  connectedCallback() {
    const main = document.querySelector('[data-main-add]');
    if (!main || !('IntersectionObserver' in window)) return;
    const hideTargets = [...document.querySelectorAll('[data-sticky-buy-hide]')];

    this.#observer = new IntersectionObserver((entries) => {
      for (const entry of entries) {
        if (entry.target === main) {
          // Only show once the button has left through the top, not before the shopper reaches it.
          this.#mainPassed = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        } else if (entry.isIntersecting) {
          this.#hideVisible.add(entry.target);
        } else {
          this.#hideVisible.delete(entry.target);
        }
      }
      this.hidden = !(this.#mainPassed && this.#hideVisible.size === 0);
    });

    this.#observer.observe(main);
    hideTargets.forEach((target) => this.#observer.observe(target));
  }

  disconnectedCallback() {
    this.#observer?.disconnect();
  }
}

if (!customElements.get('s-sticky-buy')) customElements.define('s-sticky-buy', SStickyBuy);
